interface PriceSchedule {
  startTime: string;
  endTime: string;
  price: number;
}

export const calculateChargingFee = (
  startTime: Date,
  endTime: Date,
  priceSchedules: PriceSchedule[],
  energyConsumed: number
): number => {
  console.log('Fee calculation inputs:', {
    startTime: startTime.toISOString(),
    endTime: endTime.toISOString(),
    priceSchedules,
    energyConsumed
  });

  if (!priceSchedules || priceSchedules.length === 0) {
    console.warn('No price schedules provided');
    return 0;
  }

  if (energyConsumed <= 0) {
    console.warn('No energy consumed');
    return 0;
  }

  if (priceSchedules.length === 1) {
    const fee = energyConsumed * priceSchedules[0].price;
    console.log('Single price calculation:', {
      energy: energyConsumed,
      price: priceSchedules[0].price,
      fee
    });
    return fee;
  }

  let totalFee = 0;
  let currentTime = new Date(startTime);

  while (currentTime < endTime) {
    const timeStr = currentTime.toTimeString().slice(0, 5);
    const applicableSchedule = priceSchedules.find(schedule => {
      if (schedule.startTime <= schedule.endTime) {
        return timeStr >= schedule.startTime && timeStr < schedule.endTime;
      } else {
        return timeStr >= schedule.startTime || timeStr < schedule.endTime;
      }
    });

    if (!applicableSchedule) {
      console.warn('No applicable price schedule found for time:', timeStr);
    }

    const nextMinute = new Date(currentTime.getTime() + 60000);
    const endTimeForMinute = nextMinute > endTime ? endTime : nextMinute;
    const minuteDuration = (endTimeForMinute.getTime() - currentTime.getTime()) / (1000 * 60);
    const energyForMinute = (energyConsumed * minuteDuration) / 
      ((endTime.getTime() - startTime.getTime()) / (1000 * 60));

    const price = applicableSchedule?.price || priceSchedules[0].price;
    const minuteFee = energyForMinute * price;
    
    console.log('Minute calculation:', {
      timeStr,
      minuteDuration,
      energyForMinute,
      price,
      minuteFee
    });

    totalFee += minuteFee;
    currentTime = nextMinute;
  }

  console.log('Final fee calculation:', {
    totalFee: Math.round(totalFee),
    totalEnergy: energyConsumed
  });

  return Math.round(totalFee);
}; 